// extracted by mini-css-extract-plugin
module.exports = {"container":"sk_e","button":"sk_es g2_g3","buttonLess":"sk_sl sk_es g2_g3","buttonWhite":"sk_sm sk_es g2_g3"};